import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEntityCrud } from '../hooks/useEntityCrud';
import { toast } from 'react-toastify';

const Transfer = () => {

    const navigate = useNavigate();
    const [segments,setSegments] = useState([]);
    const [segmentId,setSegmentId] = useState('');
    const [amount,setAmount] = useState('');
    const [cardNo,setCardNo] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const { readData } = useEntityCrud('Info/GetTransferTypes');
    const { addData } = useEntityCrud('Transfer/DoTransfer');

    useEffect(() => {
        readData().then(({ data }) => {
            if(data.status)
                setSegments([...data.result.filter(item => item.isActive)]);
        })
    },[])

    const submit = () => {
        setIsLoading(true);
        if(!segmentId || !amount || !cardNo) return
        const segment = segments.find(s => s.id == segmentId)
        const postedData = {
            src: segment.source,
            dst: segment.destination,
            amount: amount,
            cardNo
        }
        addData(postedData).then(({ data }) => {
            if(data.status){
                toast.success('انتقال وجه با موفقیت انجام شد');
                setSegmentId('')
                setAmount('')
                setCardNo('')
            }
            else
                toast.error(data.message);
        }).finally(() => {
            setIsLoading(false);
        })
    }

    const handleBack = () => {
        navigate(-1);
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">انتقال اعتبار</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-3">
                        <div className="form-group">
                            <label>مبدا و مقصد انتقال</label>
                            <select className={`form-control ${!segmentId ? 'is-invalid' : ''}`} onChange={e => setSegmentId(e.target.value)}>
                                <option value="">انتخاب کنید</option>
                                {segments.map(segment => <option key={segment.id} value={segment.id}>
                                    {segment.sourceTitle} به {segment.destinationTitle}
                                </option>)}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>مبلغ</label>
                            <input type="tel" className={`form-control ltr-input ${!amount ? 'is-invalid' : ''}`} value={amount} onChange={e => setAmount(e.target.value)} />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>شماره کارت</label>
                            <input type="tel" maxLength={16} className={`form-control ltr-input ${!cardNo ? 'is-invalid' : ''}`} value={cardNo} onChange={e => setCardNo(e.target.value)} />
                        </div>
                    </div>
                    <div className="col-md-3" style={{marginTop: '30px'}}>
                        <button className={`btn btn-success ${isLoading ? 'btn-loading' : ''}`} disabled={!segmentId || !amount || !cardNo || isLoading} onClick={submit}>انجام انتقال</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Transfer